import React from 'react';

const AudioPause = ({ color, ...props }) => (
    <svg height="36" viewBox="0 0 36 36" width="36" {...props}>
        <linearGradient id="a">
            <stop offset="0" stop-color="#d34f94" />
            <stop offset="1" stop-color="#f7a76f" />
        </linearGradient>
        <radialGradient
            id="b"
            cx="16.47022%"
            cy="0%"
            r="149.930721%"
            xlinkHref="#a"
        />
        <radialGradient
            id="c"
            cx="16.47022%"
            cy="0%"
            gradientTransform="matrix(.11386338 .14192792 -.99349642 .01626618 .145948 -.023376)"
            r="823.988686%"
            xlinkHref="#a"
        />
        <g fill="none" fill-rule="evenodd">
            <path
                d="m18 0c-4.77432 0-9.3528 1.89702-12.7278 5.2722s-5.2722 7.95384-5.2722 12.7278 1.89702 9.3528 5.2722 12.7278 7.95384 5.2722 12.7278 5.2722 9.3528-1.89702 12.7278-5.2722 5.2722-7.95384 5.2722-12.7278-1.89702-9.3528-5.2722-12.7278-7.95384-5.2722-12.7278-5.2722zm0 34.0002c-4.24404 0-8.31384-1.686096-11.31336-4.6872-3.000924-2.99952-4.68720036-7.06932-4.68720036-11.31336s1.68609636-8.31384 4.68720036-11.31336c2.99952-3.000924 7.06932-4.6872 11.31336-4.6872s8.31384 1.686096 11.31336 4.6872c3.000924 2.99952 4.6872 7.06932 4.6872 11.31336-.0056232 4.2426-1.691712 8.30952-4.69116 11.30904-2.99952 2.99952-7.06644 4.6857593-11.30904 4.6911593z"
                fill={color || 'url(#b)'}
            />
            <g fill={color || 'url(#c)'}>
                <path d="m15 11c-.5527671 0-1 .4485797-1 .9997874v12.0004288c0 .5512077.4472689.9997838 1 .9997838.5513268 0 1-.4485761 1-.9997838v-12.0004288c0-.2643651-.1054873-.5188811-.2939582-.7058928-.1870629-.1884301-.4416519-.2938946-.7060418-.2938946z" />
                <path d="m21 11c-.5513268 0-1 .4485797-1 .9997874v12.0004288c0 .5512077.4486732.9997838 1 .9997838.5527671 0 1-.4485761 1-.9997838v-12.0004288c0-.2643651-.1040795-.5188811-.2925503-.7058928-.187063-.1884301-.441652-.2938946-.7074497-.2938946z" />
            </g>
        </g>
    </svg>
);

export default AudioPause;
